"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorSubstituteContractsListApiResponseSchema = exports.getDoctorSubstituteContractItemApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const add_doctor_substitute_contract_1 = require("./add-doctor-substitute-contract");
// Data
exports.getDoctorSubstituteContractItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-substitute-contracts'),
    attributes: zod_1.z.object({
        from: zod_1.z.string(),
        to: zod_1.z.string(),
        retrocessionRate: zod_1.z.number().nullable(),
        documentUrl: zod_1.z.string(),
        doctorSubstituteSignedAt: zod_1.z.coerce.date().nullable(),
        metadata: add_doctor_substitute_contract_1.doctorSubstituteContractMetadata,
        createdAt: zod_1.z.coerce.date(),
    }),
});
// Api
exports.getDoctorSubstituteContractsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getDoctorSubstituteContractItemApiResponseSchema);
